export default "__VITE_ASSET__DiwbHVxH__"